import Report from './Report'
import ReportBranch from './ReportBranch'
import ReportDashBoard from './ReportDashBoard'
import ReportDashBoardVacine from './ReportDashBoardVacine'
import ReportDashBoardVacineCategory from './ReportDashBoardVacineCategory'
import ReportVaccine from './ReportVaccine'
import ReportCovidHelp from './ReportCovidHelp'
import LineNotifyCovid from './LineNotifyCovid'

export default {
  Report,
  ReportBranch,
  ReportVaccine,
  ReportCovidHelp,
  LineNotifyCovid,
  ReportDashBoard,
  ReportDashBoardVacine,
  ReportDashBoardVacineCategory
}



// WEBPACK FOOTER //
// ./src/components/HRM/ReportCovid/index.js